import React from 'react';
import Assessments from 'pages/assessments/assessments';
import { useAuth } from '../../providers/auth-provider';
import ClientDashboard from '../client-dashboard/client-dashboard';
import CandidateCompare from '../candidate-compare/candidate-compare';

function Home({ displayAssessments, displayCompare = false }) {
  const { isLeader } = useAuth();

  return (
    <>
      {displayAssessments && <Assessments />}
      {isLeader() && !displayAssessments && <ClientDashboard />}
      {displayCompare && <CandidateCompare />}
    </>
  );
}

export default Home;
